<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<div>
  <fab-loading-spinner color="primary" [hidden]="!showSpinner"></fab-loading-spinner>
</div>
<div class="d-flex justify-content-between">
  <h1 mat-dialog-title>Edit Vehicle Scenario</h1>
  <div class="actions-container default-padding">
    <button mat-stroked-button id="cancel-button" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" id="submit-button" (click)="onSubmit()"
            [disabled]="!vehicleScenarioForm.valid">
      Submit
    </button>
  </div>
</div>

<div mat-dialog-content style="padding-top: unset; max-height:70vh">
  <form class="d-flex flex-column gap-8" [formGroup]="vehicleScenarioForm">
    <div class="d-flex gap-8">
      <mat-form-field class="d-flex flex-grow-1" subscriptSizing="dynamic">
        <mat-label>Enter Scenario</mat-label>
        <input matInput maxlength="35" id="scenario-input" formControlName="updatedVehicleScenarioName"
               [(ngModel)]="vehicleScenario.vehScenName"
               value="{{ vehicleScenario.vehScenName }}"/>
      </mat-form-field>
      <mat-form-field class="d-flex flex-grow-1" subscriptSizing="dynamic">
        <mat-label>Scenario Category/Forecast Gate</mat-label>
        <mat-select [(ngModel)]="vehicleScenario.scenCat"
                    formControlName="updatedScenarioCategory">
          <mat-option *ngFor="let scenarioCategory of scenarioCategories" [value]="scenarioCategory.scenarioCategory">
            {{ scenarioCategory.scenarioCategory }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="d-flex flex-grow-1" subscriptSizing="dynamic">
        <mat-label>Scenario Type</mat-label>
        <mat-select [(ngModel)]="vehicleScenario.scenType" formControlName="updatedScenarioType">
          <mat-option *ngFor="let scenarioType of scenarioTypes" [value]="scenarioType['SCEN_TYPE']">
            {{ scenarioType["SCEN_TYPE"] }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div *ngIf="vehicleScenario.fcorg  === 'GMTVP'" class="d-flex gap-8">
      <mat-form-field class="d-flex flex-grow-1" subscriptSizing="dynamic">
        <mat-label>Propulsion Type</mat-label>
        <mat-select [(ngModel)]="vehicleScenario.propulsionType.id" formControlName="updatedPropulsionType">
          <mat-option *ngFor="let propulsionType of propulsionTypes" [value]="propulsionType.id">
            {{ propulsionType.propulsionType }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="d-flex flex-grow-1" subscriptSizing="dynamic">
        <mat-label>Forecast State</mat-label>
        <mat-select [(ngModel)]="vehicleScenario.forecastState.id" formControlName="updatedForecastState">
          <mat-option *ngFor="let forecastState of forecastStates" [value]="forecastState.id">
            {{ forecastState.forecastState }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="d-flex flex-grow-1" subscriptSizing="dynamic">
        <mat-label>Engineering Program Class</mat-label>
        <mat-select [(ngModel)]="vehicleScenario.engProgClass.id" formControlName="updatedEngProgClass">
          <mat-option *ngFor="let engProgClass of engProgClasses" [value]="engProgClass.id">
            {{ engProgClass.engProgClass }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <mat-form-field subscriptSizing="dynamic"
                    (click)="resetValue()">
      <mat-label>Industry Scenario</mat-label>
      <input type="text" id="industryScenarioInput"
             formControlName="updatedIndustryScenario"
             [(ngModel)]="vehicleScenario.industryScenario"
             matInput
             [matAutocomplete]="autoIndustryScenario"/>
      <mat-autocomplete #autoIndustryScenario="matAutocomplete" [displayWith]="displayIndustryScenarioValue">
        <mat-option *ngFor="let industryScenario of filteredIndustryScenarios | async" [value]="industryScenario">
          {{ industryScenario.id }}  {{ industryScenario.industryScenarioName }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Enter Scenario Assumption</mat-label>
      <textarea formControlName="updatedAssumption" matInput rows="1" maxlength="150"
                id="scenario-assumption-input"
                [(ngModel)]="vehicleScenario.vehScenAsmptn"
                value="{{ vehicleScenario.vehScenAsmptn }}">
    </textarea>
    </mat-form-field>
    <div class="radio-button-group justify-content-center" *ngIf="isAdmin">
      <div id="del-lock-container" class="default-margin">
        <mat-label>Delete Lock:</mat-label>
        <mat-radio-group aria-label="Select an option" class="radio-group" formControlName="updatedIsDeleteLocked">
          <div *ngIf="vehicleScenario.isDeleteLocked === true; then selectDeleteLock else selectDeleteUnlock">

          </div>
          <ng-template #selectDeleteLock>
            <div>
              <mat-radio-button checked value=true>ON</mat-radio-button>
              <br/>
              <mat-radio-button value=false>OFF</mat-radio-button>
            </div>
          </ng-template>

          <ng-template #selectDeleteUnlock>
            <div>
              <mat-radio-button value=true>ON</mat-radio-button>
              <br/>
              <mat-radio-button checked value=false>OFF</mat-radio-button>
            </div>
          </ng-template>
        </mat-radio-group>
      </div>
      <div id="edit-lock-container" class="default-margin">
        <mat-label>Edit Lock:</mat-label>
        <mat-radio-group aria-label="Select an option" class="radio-group" formControlName="updatedIsEditLocked">
          <div *ngIf="vehicleScenario.isEditLocked === true; then selectEditLock else selectEditUnlock">
          </div>
          <ng-template #selectEditLock>
            <div>
              <mat-radio-button checked value="true">ON</mat-radio-button>
              <br/>
              <mat-radio-button value="false">OFF</mat-radio-button>
            </div>
          </ng-template>

          <ng-template #selectEditUnlock>
            <div>
              <mat-radio-button value="true">ON</mat-radio-button>
              <br/>
              <mat-radio-button checked value="false">OFF</mat-radio-button>
            </div>
          </ng-template>
        </mat-radio-group>
      </div>

      <div id="hidden-container" class="default-margin">
        <mat-label>Hide Scenario:</mat-label>
        <mat-radio-group aria-label="Select an option" class="radio-group" formControlName="updatedIsHiddenLocked">
          <div *ngIf="vehicleScenario.isHidden === true; then selectHiddenLock else selectHiddenUnlock">
          </div>
          <ng-template #selectHiddenLock>
            <div>
              <mat-radio-button checked value="true">ON</mat-radio-button>
              <br/>
              <mat-radio-button value="false">OFF</mat-radio-button>
            </div>
          </ng-template>

          <ng-template #selectHiddenUnlock>
            <div>
              <mat-radio-button value="true">ON</mat-radio-button>
              <br/>
              <mat-radio-button checked value="false">OFF</mat-radio-button>
            </div>
          </ng-template>
        </mat-radio-group>
      </div>
    </div>

  </form>

</div>
